__turbopack_context__.v({
  "fullSchedule": "schedule-block-module__igu8jG__fullSchedule",
  "label": "schedule-block-module__igu8jG__label",
  "scroller": "schedule-block-module__igu8jG__scroller",
});
